import {Nullable} from '@fl/cmsch-fe-library';

/** Redux form name for the export-animals form. */
export const exportAnimalsFormName = 'exportAnimals';

/** Form values used by the export-animals form. */
export interface ExportAnimalsFormValues {
    /** File name entered by the user. */
    exportAnimalsInList: Nullable<string>;
}

/** Initial export-animals form values. */
export const exportAnimalsFormInitialValues: ExportAnimalsFormValues = {
    exportAnimalsInList: null,
};
